import React from "react";

export const TabletPage: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div
    className="bg-bg-50 dark:bg-bg-50-dark rounded-xl relative flex flex-col items-stretch justify-start w-full mb-8"
  >
    {children}
  </div>
);

export const TabletContainer: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div className={`tablet-container px-6 xl:px-8 ${className ?? ""}`.trim()}>{children}</div>
);

export default TabletPage;
